import {Box, Typography} from '@mui/material';

import {analysisInputSectionLabelSx} from './workforceProfileAnalysisDataInputSectionSx';
import {WorkforceProfileExtractedCandidateProfile} from '../../types/WorkforceProfileTypes';

export interface Props {
  profile: WorkforceProfileExtractedCandidateProfile;
  labels: Record<string, string>;
}

export const WorkforceProfileAnalysisInputCandidateProfileFields = ({profile, labels}: Props) => {
  const fields: Array<{key: keyof WorkforceProfileExtractedCandidateProfile; label: string}> = [
    {key: 'summary', label: labels.summary},
    {key: 'education', label: labels.education},
    {key: 'responsibilities', label: labels.responsibilities},
    {key: 'senioritySignals', label: labels.senioritySignals},
    {key: 'industryExperience', label: labels.industryExperience},
    {key: 'workingStyleNotes', label: labels.workingStyleNotes},
  ];

  return (
    <Box>
      {fields.map(({key, label}) => {
        const value = profile[key];

        if (!value) {
          return null;
        }

        return (
          <Box key={key} sx={{mb: 1.5}}>
            <Typography variant='caption' sx={{...analysisInputSectionLabelSx, display: 'block', mb: 0.25}}>
              {label}
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{lineHeight: 1.6, whiteSpace: 'pre-wrap'}}>
              {value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
